import React from "react";
import type { PrescribedQuantityProps } from "../../types";
import * as Styles from "./QuantityStyles";

const PrescribedQuantity: React.FC<PrescribedQuantityProps> = ({
  prescribedAmount,
  unit,
}) => {
  return (
    <Styles.PrescribedQuantityContainer>
      <Styles.PrescribedQuantityCircleWrapper>
        <Styles.PrescribedQuantityCircleContent>
          <Styles.PrescribedQuantitySvg viewBox="0 0 24 24">
            <circle
              cx="12"
              cy="12"
              r="9"
              fill="#f3f4f6"
              stroke="#e5e7eb"
              strokeWidth="3"
            />
          </Styles.PrescribedQuantitySvg>
          <Styles.PrescribedQuantityText>
            {prescribedAmount}
          </Styles.PrescribedQuantityText>
        </Styles.PrescribedQuantityCircleContent>
      </Styles.PrescribedQuantityCircleWrapper>
      <Styles.PrescribedQuantityUnit>{unit}</Styles.PrescribedQuantityUnit>
    </Styles.PrescribedQuantityContainer>
  );
};

export default PrescribedQuantity;